export default __webpack_public_path__ + "img/square_1.1dfdaafbd7adbfc1d1025b56f666f1d3.jpg";